module.exports = "pegasus/assets/theme4/medium/4.jpg";